export const common = {
  getCategoryList: '/common/business/category',
  // HTTP METHOD : GET,
  getEnum: '/common/enum',
  // HTTP METHOD : GET
  getCommentTemplate: '/common/comment/template',
  // HTTP METHOD : GET
  // PARAMETERS : page,limit
  nativeLog: '/common/nativeCall',
  inAppPurchase: '/api/payment/app/purchase',
  webPurchase: '/api/payment/web/purchase',
  pointPurchase: '/api/payment/point/purchase',
  getBibleList: '/common/bible',
  insertValidCheck: (userNo, type) => `/api/payment/valid/${userNo}/${type}`,
  getProductBusinessList: (userNo, type) => `/api/payment/business/${userNo}/${type}`,
  marketingFirstBuyCheck: (userNo, businessNo) => `/api/payment/marketing/first/${userNo}/${businessNo}`,
  fetchNaverLocalData: keyword => `/common/naver/local/${keyword}`, // GET) 네이버 지역 검색
  fetchOverseasGeocode: keyword => `/common/geocode/overseas/${keyword}`, // GET) 해외 주소 지오코딩(OSM)
  getHoliday: keyword => `/common/holiday` // GET) 공휴일 가져오기
};

// 260624: 블로그 글 리더(소비자) — 발행 글만. 비로그인 열람(security auth-ignore 등재).
export const post = {
  getList: '/api/post',
  // GET — BaseParameter(page/limit/searchText) + themeType 옵션
  getDetail: '/api/post/',
  // GET — PathVariable: postNo (조회수 +1)
  getByBusiness: '/api/post/business/'
  // GET — PathVariable: businessNo (간판 상세 '이 기업과 관련된 글')
};

export const businessUser = {
  getAddressList: '/api/user/business/address',
  // HTTP METHOD : GET,
  // PARAMETER : BaseParameter ( userNo ),
  getProductList: '/api/user/business/product',
  // HTTP METHOD : GET
  // PARAMETER : ProductCode,
  getBusiness: (businessNo, userNo) => `/api/user/business/detail/${businessNo}/${userNo}`,
  // 260713 비회원 티저 상세 — PII·갤러리·이벤트 없이 회원가입 유도용(서버가 원천 미전송). 게스트 앱 흐름 전용.
  getBusinessGuest: businessNo => `/api/user/business/detail/guest/${businessNo}`,
  // 261013 기업 상세 '해당 기업 QR 보기' — 개통 현판 코드({ qrCode }, 없으면 null). 로그인 회원만(공개 목록 아님).
  getPlate: businessNo => `/api/user/business/plate/${businessNo}`,
  // HTTP METHOD : GET
  // PathVariable: businessNo,
  getBusinessList: `/api/user/business/list`,
  // 260522: 검색 mix-in — searchText 있을 때 page=1 호출 시 네이버 미가입 ghost 카드 함께 반환 (똑딱 모델)
  getBusinessListWithGhost: `/api/user/business/list-with-ghost`,
  // 260720 교회 전용 디렉토리 — 교회(108)만(BE onlyChurch=true), 공개 소비뷰(userNo=null). /list와 카드 shape 동일. security auth-ignore 3환경 등재 필요.
  getChurchList: `/api/user/business/church/list`,
  // 260429: 마이페이지 전용 — JWT principal로 owner 강제 (메인 피드와 격리)
  getMyBusinessList: `/api/user/business/my/list`,
  // HTTP METHOD : GET
  // PathVariable: BusinessParameter,
  getLikeList: `/api/user/business/like/list`,
  // 260428: 마케팅 알림 구독한 사업장 목록
  getSubscribedList: `/api/user/business/subscribe/list`,
  // 260429: 좋아요/알림 페이지 발견용 — 본인이 안 누른 가게 거리순 추천
  recommendLikeTargets: `/api/user/business/recommend/like-target`,
  recommendSubscribeTargets: `/api/user/business/recommend/subscribe-target`,
  // HTTP METHOD : GET
  // PathVariable: BusinessParameter,
  likeBusiness: (businessNo, userNo) => `/api/user/business/like/${businessNo}/${userNo}`,
  // 비즈니스 구독 (종 버튼) — 마케팅 푸시 대상
  subscribeBusiness: businessNo => `/api/user/business/subscribe/${businessNo}`,
  // HTTP METHOD : POST
  // PARAMETER : SaveBusinessRequest
  saveBusiness: '/api/user/business/save',
  verifyLicense: '/api/user/business/verify-license',
  registerSimple: '/api/user/business/register-simple',
  placeSearch: '/api/user/business/place/search', // 260909 등록 2단계 사업장 이름 검색 → 260917 공공데이터 디렉토리(tblPublicPlace). GET ?q=(2~40자)&limit=(1..15)[&lat&lng = 261016 가까운 순, 없으면 시·도마다 한 곳씩] → PublicPlaceHit 15키 + businessCategoryNo: [{placeNo,name,branchName,roadAddress,lotAddress,sido,sigungu,latitude,longitude,categoryKey,categoryLabel,phone,source,sourceLabel,baseDate,businessCategoryNo}]. 좌표는 문자열, businessCategoryNo 는 업종 역매핑 실패 시 null
  placeLink: '/api/user/business/place/link', // 260909 수정 마법사 연결. POST { businessNo, placeNo } (JWT, 본인 ACTIVE 업체만) → { filled: [] }(260917 부터 항상 빈 배열). tblBusiness.placeNo 만 덮어쓴다 — 빈 칸 채움 없음
  // 260602: 비즈니스 소개 5지선다 → GPT 서술형 생성 (수정단 전용)
  // HTTP METHOD : POST / PARAMETER : { categoryName, businessName, answers[] }
  generateIntro: '/api/user/business/intro/generate',
  // 260604: 업종별 해시태그 AI 생성 { categoryName, businessName, region } → string[]
  aiTags: '/api/user/business/ai-tags',
  // 260629: 사장측 RAG Slice1 — 기업 성장 AI 분석 (오너 전용, growth_ai flag). businessNo append.
  growthAnalyze: '/api/user/business/growth/analyze', // POST .../{businessNo}?force=true
  growthLatest: '/api/user/business/growth',          // GET  .../{businessNo}
  growthGeneral: '/api/user/business/growth/general',  // GET  .../{businessNo} — 일반 분석(사실 카드, LLM 0콜)
  growthB2b: '/api/user/business/growth/b2b',         // POST .../{businessNo} — RAG B2B 협업 추천
  growthProfile: '/api/user/business/growth/profile', // GET/POST .../{businessNo} — 가게 DNA 선답지(매칭 데이터)
  growthB2bWaitlist: '/api/user/business/growth/b2b/waitlist', // POST .../{businessNo} — 보완 업체 없을 때 대기 신청
  // HTTP METHOD : POST
  // PARAMETER : SaveBusinessRequest
  updateBusiness: '/api/user/business/update',
  // HTTP METHOD : PUT
  // PARAMETER : SaveBusinessRequest
  saveAddress: '/api/user/business/address',
  // HTTP METHOD : POST
  // PARAMETER : BusinessAddressRequest
  removeAddress: addressNo => `/api/user/business/address/${addressNo}`,
  // HTTP METHOD : DELETE
  // PathVariable : businessNo
  removeBusiness: businessNo => `/api/user/business/${businessNo}`,
  // HTTP METHOD : DELETE
  // PathVariable : businessNo
  reportBusiness: '/api/user/business/report',
  // HTTP METHOD : POST
  // PARAMETER : BusinessReportRequest,
  saveMarketing: '/api/user/business/marketing/save',
  // HTTP METHOD : POST
  // PARAMETER : BusinessMarketingRequest
  updateMarketing: '/api/user/business/marketing/update',
  // HTTP METHOD : PUT
  // PARAMETER : BusinessMarketingRequest
  getMarketing: marketingNo => `/api/user/business/marketing/detail/${marketingNo}`,
  // HTTP METHOD : POST
  // PARAMETER : BusinessMarketingRequest
  marketingTicketCount: userNo => `/api/user/business/marketing/ticket/count/${userNo}`,
  // HTTP METHOD : GET
  // PathVariable : userNo
  ticketUse: (userNo, businessNo, isPoint) =>
    `/api/user/business/marketing/ticket/use/${userNo}/${businessNo}/${isPoint}`,
  // HTTP METHOD : GET
  // PathVariable : userNo,
  ticketRePurchase: (userNo, businessNo, isPoint) =>
    `/api/user/business/marketing/ticket/repurchase/${userNo}/${businessNo}/${isPoint}`,
  // HTTP METHOD : GET
  // PathVariable : userNo,
  reportMarketing: `/api/user/business/marketing/report`,
  // HTTP METHOD : POST
  // Parameters : BusinessMarketingReportRequest
  sendPush: marketingNo => `/api/user/business/marketing/push/${marketingNo}`,
  // HTTP METHOD : POST
  // PathVariable : marketingNo
  temporarySave: `/api/user/business/temporary`,
  // HTTP METHOD : POST
  // Parameters : BusinessImageTicketRequest
  getMarketingPurchaseList: `/api/user/business/marketing/purchase`,
  // HTTP METHOD : GET
  // PARAMETERS : BaseParameter
  getTicketUseList: `/api/user/business/marketing/ticket/use`,
  // HTTP METHOD : GET
  // PARAMETERS : BaseParameter
  selectAddress: (userNo, addressNo) => `/api/user/business/address/select/${userNo}/${addressNo}`,
  // HTTP METHOD : POST
  // PathVariable : userNo , addressNo,
  getSelectAddress: userNo => `/api/user/business/address/select/${userNo}`,
  // HTTP METHOD : GET
  // PathVariable : userNo
  licenseNumberValid: licenseNumber => `/api/user/business/licenseNumber/${licenseNumber}`,
  // HTTP METHOD : POST
  // PARAMETER : SaveBusinessRequest
  imageMaxSize: `/api/user/business/image/max`,
  // HTTP METHOD : GET
  // PARAMETER : BusinessImageTicketRequest
  marketingImageTicketUse: `/api/user/business/marketing/image/use`,
  // HTTP METHOD : POST
  // PARAMETER : BusinessImageTicketRequest
  donationImageTicketUse: `/api/user/business/donation/image/use`,
  // HTTP METHOD : POST
  // PARAMETER : BusinessImageTicketRequest
  getDonation: donationNo => `/api/user/business/donation/detail/${donationNo}`,
  // HTTP METHOD : Get
  // PathVariable : donationNo
  saveDonation: '/api/user/business/donation/save',
  // HTTP METHOD : POST
  // PARAMETER : BusinessDonationRequest
  updateDonation: '/api/user/business/donation/update',
  // HTTP METHOD : PATCH
  // PARAMETER : BusinessDonationRequest
  donationSendPush: donationNo => `/api/user/business/donation/push/${donationNo}`,
  // HTTP METHOD : POST
  // PathVariable : donationNo
  reportDonation: `/api/user/business/donation/report`,
  // HTTP METHOD : POST
  // Parameters : BusinessMarketingReportRequest
  getJob: jobNo => `/api/user/business/job/detail/${jobNo}`,
  // HTTP METHOD : Get
  // PathVariable : donationNo
  saveJob: '/api/user/business/job/save',
  // HTTP METHOD : POST
  // PARAMETER : BusinessDonationRequest
  updateJob: '/api/user/business/job/update',
  // HTTP METHOD : PATCH
  // PARAMETER : BusinessDonationRequest
  jobSendPush: jobNo => `/api/user/business/job/push/${jobNo}`,
  // HTTP METHOD : POST
  // PathVariable : donationNo
  reportJob: `/api/user/business/job/report`,
  // HTTP METHOD : POST
  // Parameters : BusinessMarketingReportRequest,
  deleteJob: jobNo => `/api/user/business/job/delete/${jobNo}`,
  deleteDonation: donationNo => `/api/user/business/donation/delete/${donationNo}`,
  deleteMarketing: marketingNo => `/api/user/business/marketing/delete/${marketingNo}`
};

// 260507 협업 제안 (DM 형식). 회의 결정 (260506 오후): 비즈니스 상세 → 폼 → 받는 기업 inbox + 알림 + 숫자 배지
export const cooperation = {
  send: '/api/user/business/cooperation/send',
  inbox: '/api/user/business/cooperation/inbox',
  // 260526: 보낸 제안함 (sent). businessNo=fromBusinessNo 기준. readStatus/readAt 포함.
  sent: '/api/user/business/cooperation/sent',
  detail: proposalNo => `/api/user/business/cooperation/detail/${proposalNo}`,
  // 260526: 보낸 제안 단건 상세 (발신자용). fromBusiness owner만 열람.
  sentDetail: no => '/api/user/business/cooperation/sent/' + no,
  read: proposalNo => `/api/user/business/cooperation/read/${proposalNo}`,
  count: '/api/user/business/cooperation/count'
};

// 260507 구인 지원 (당근마켓 스타일). 회의 결정 (260506 오후): 비로그인 열람 + 지원하기 + 이력서 첨부
export const jobApplication = {
  apply: '/api/user/business/job/application/apply',
  list: '/api/user/business/job/application/list',
  detail: applicationNo => `/api/user/business/job/application/detail/${applicationNo}`,
  read: applicationNo => `/api/user/business/job/application/read/${applicationNo}`,
  count: '/api/user/business/job/application/count'
};

// 260608 기업↔기업 B2B 연결보드 ("원합니다/구합니다"). 설계서: docs/0605_원합니다_구합니다_B2B연결보드_설계서.md
// base = /api/user/business/b2b. category / post/list / post/{postNo} 는 비로그인 허용(security 3곳 등재).
// 등록·문의(POST)는 로그인+사업자 게이트. userNo는 BE에서 JWT principal 강제 주입(클라 userNo 신뢰 금지).
export const b2bBoard = {
  // GET) 카테고리+하위옵션 목록 (비로그인 허용)
  category: '/api/user/business/b2b/category',
  // GET) 공개 목록 페이징. ?categoryCode=&direction=&keyword=&page=0&size=20 (비로그인 허용)
  postList: '/api/user/business/b2b/post/list',
  // GET) 상세(viewCount++). (비로그인 허용)
  post: postNo => `/api/user/business/b2b/post/${postNo}`,
  // POST) 등록 (로그인+사업자)
  savePost: '/api/user/business/b2b/post',
  // PUT) 수정 (로그인+소유권). 본문만 갱신
  updatePost: postNo => `/api/user/business/b2b/post/${postNo}`,
  // POST(multipart 'image')/DELETE) 글 사진 등록·교체/삭제 (로그인+소유권)
  postImage: postNo => `/api/user/business/b2b/post/${postNo}/image`,
  // GET) 내 글 목록 (로그인)
  myPosts: '/api/user/business/b2b/post/my',
  // GET) 내 소유 업체를 대상(targetBusinessNo)으로 지정한 받은 도움 요청 목록 (로그인)
  receivedWants: '/api/user/business/b2b/post/received',
  // PATCH) 상태 변경 body{status} 소유자만 (로그인+소유권)
  postStatus: postNo => `/api/user/business/b2b/post/${postNo}/status`,
  // POST) 문의 (로그인+사업자)
  inquiry: '/api/user/business/b2b/inquiry',
  // GET) 내 글에 온 문의. ?postNo= (로그인)
  inquiryReceived: '/api/user/business/b2b/inquiry/received',
  // GET) 문의 상세+읽음처리 (로그인+소유권)
  inquiryDetail: inquiryNo => `/api/user/business/b2b/inquiry/${inquiryNo}`
};

// 260608 이벤트 가입(커피 쿠폰) 트랙 — 골격. base = /api/user/event.
// store/list 만 비로그인 허용(드랍박스 '이벤트 가게 선택'). 발급·내쿠폰·차감은 로그인.
// 계약 전 — FE 진입은 feature flag coffeeEventEnabled 로 잠금(준비중 모달).
export const eventCoupon = {
  // 260923 대표: 메가커피 이벤트 중단 — 받는 경로 키(storeList·issue·shareCodeMy·redeemCode·verifyCode) 삭제. 쿠폰함·운영진 패널용만 남김.
  // GET) 내 쿠폰 목록 (로그인)
  myCoupons: '/api/user/event/coupon/my',
  // PATCH) 직원 확인 → 소멸 (로그인+본인 쿠폰)
  redeem: couponNo => `/api/user/event/coupon/${couponNo}/redeem`,
  // 260618 PATCH) 쿠폰 지우기 → 쿠폰함에서 숨김 (로그인+본인 쿠폰)
  hide: couponNo => `/api/user/event/coupon/${couponNo}/hide`,
  // 260915 운영진(와쳐) 메가커피 쿠폰 발급/반납 — 로그인 + BE 와쳐 검증(폰 상수) + flag event.watch.mega.enabled
  // GET) { watcher, remaining, liveCouponNo }  — 비와쳐는 watcher=false 만
  watchStatus: '/api/user/event/coupon/watch/status',
  // POST) SHARE 풀에서 1장 발급(1인 1장) → 발급된 쿠폰
  watchIssue: '/api/user/event/coupon/watch/issue',
  // PATCH) 미사용 쿠폰 반납 → 풀 복구
  watchReturn: couponNo => `/api/user/event/coupon/${couponNo}/return`
};

export const businessCard = {
  saveCard: '/api/user/card/save',
  aiGenerate: '/api/user/card/ai-generate',
  aiBalance: '/api/user/card/ai-balance', // 260625: AI 생성권 잔액 {hasActiveSession, sessionId, remaining}
  // 260814: 비동기 생성(시작→폴링). 동기 ai-generate 는 레거시로 보존.
  aiGenerateAsync: '/api/user/card/ai-generate-async',
  aiGenerateStatus: (userNo, jobId) => `/api/user/card/ai-generate-status?jobId=${jobId}&userNo=${userNo}`,
  getMyCards: userNo => `/api/user/card/list/${userNo}`,
  getCard: cardNo => `/api/user/card/detail/${cardNo}`,
  updateCard: '/api/user/card/update',
  deleteCard: (cardNo, userNo) => `/api/user/card/delete/${cardNo}/${userNo}`,
  receiveCard: cardNo => `/api/user/card/receive/${cardNo}`,
  getReceivedCards: userNo => `/api/user/card/receive/list/${userNo}`,
  deleteReceivedCard: (cardNo, userNo) => `/api/user/card/receive/delete/${cardNo}/${userNo}`
};

// 260619: AI 전단지
export const flyer = {
  aiGenerate: '/api/user/flyer/ai-generate',
  aiBalance: '/api/user/flyer/ai-balance', // 260625: AI 생성권 잔액 {hasActiveSession, sessionId, remaining}
  // 260622: 비동기 생성(시작→폴링). 60초+ 동기요청 ALB 끊김 회피 + 프로그레스바
  aiGenerateAsync: '/api/user/flyer/ai-generate-async',
  aiGenerateStatus: (userNo, jobId) => `/api/user/flyer/ai-generate-status?jobId=${jobId}&userNo=${userNo}`,
  save: '/api/user/flyer/save',
  getMyFlyers: userNo => `/api/user/flyer/list/${userNo}`,
  deleteFlyer: (fileNo, userNo) => `/api/user/flyer/delete/${fileNo}/${userNo}`,
  send: (fileNo, userNo, businessCategoryNos, radiusKm) => {
    let url = `/api/user/flyer/${fileNo}/send?userNo=${userNo}`;
    if (businessCategoryNos && businessCategoryNos.length) url += `&businessCategoryNos=${businessCategoryNos.join(',')}`;
    if (radiusKm) url += `&radiusKm=${radiusKm}`;
    return url;
  },
  reach: radiusKm => `/api/user/flyer/reach?radiusKm=${radiusKm}`   // 260630 D: 발송 전 타깃 프리뷰(userNo는 JWT)
};

export const signboard = {
  getFeed: '/api/user/signboard/feed',
  getFeedRegions: '/api/user/signboard/feed/regions',
  updateRegion: '/api/user/signboard/region',
  updateNotice: '/api/user/signboard/notice',
  updateSignMarks: '/api/user/signboard/marks',
  getDetail: businessNo => `/api/user/signboard/detail/${businessNo}`,
  getMy: userNo => `/api/user/signboard/my/${userNo}`,
  create: '/api/user/signboard/create',
  saveSettings: '/api/user/signboard/settings',
  uploadImage: '/api/user/signboard/image/upload',
  delete: signboardNo => `/api/user/signboard/delete/${signboardNo}`,
  // 260428: 간판 클릭 이벤트 기록 (시간대별 통계 + 시드 자동화)
  click: signboardNo => `/api/user/signboard/click/${signboardNo}`
};

export const signboardStats = {
  summary: signboardNo => `/api/user/signboard-stats/summary/${signboardNo}`,
  shareSeries: signboardNo => `/api/user/signboard-stats/share-series/${signboardNo}`,
  shareHistory: signboardNo => `/api/user/signboard-stats/share-history/${signboardNo}`,
  // 260424 오후: A1/A2/A3 축 파생 통계
  heatmap: signboardNo => `/api/user/signboard-stats/heatmap/${signboardNo}`,
  hourly: signboardNo => `/api/user/signboard-stats/hourly/${signboardNo}`,
  weekdayIndex: signboardNo => `/api/user/signboard-stats/weekday-index/${signboardNo}`,
  // 260428: 간판 클릭(눌러본 손님) 메트릭
  clickToday: signboardNo => `/api/user/signboard-stats/click-today/${signboardNo}`,
  clickHourly: signboardNo => `/api/user/signboard-stats/click-hourly/${signboardNo}`,
  // 260428: 통계 그리드 9칸 중 5/6/8/9 통합 (weekShareCount/sumChargeHours/receivedLikeCount/subscriberCount)
  metrics: signboardNo => `/api/user/signboard-stats/metrics/${signboardNo}`,
  // 260428: 노출 통합 (누적/오늘/도달/시간대/히트맵 TOP3)
  impression: signboardNo => `/api/user/signboard-stats/impression/${signboardNo}`,
  // 260428: 타겟율 (클릭/노출 %)
  targetRate: signboardNo => `/api/user/signboard-stats/target-rate/${signboardNo}`
};

// 260430 5/1 풀스코프: 추천 시스템
export const referrals = {
  myCode: '/api/referrals/my-code',
  trackInstall: '/api/referrals/track-install',
  trackSignup: '/api/referrals/track-signup',
  status: '/api/referrals/status'
};

// 260430 5/1 풀스코프: 행위 기록 (좋아요/구독 자동 충전)
export const engagement = {
  actions: '/api/engagement/actions'
};

// 260430 5/1 풀스코프: 마케팅 동의 → 자동 충전
export const marketingV3 = {
  consents: '/api/marketing/consents'
};

// 260430 5/1 풀스코프: 알림 V2 (Phase 4 신규)
// path /api/notification/gate — 기존 /api/notification(list) + 다른 세션 /api/user/notification/settings 둘과 격리.
// 다른 세션의 notificationSettings 그룹과 기능 중복은 Phase 9에서 통합 검토.
export const notificationV2 = {
  preferences: '/api/notification/gate/preferences',
  preferencePatch: category => `/api/notification/gate/preferences/${category}`,
  quietHours: '/api/notification/gate/quiet-hours',
  marketingConsent: '/api/notification/gate/marketing-consent'
};

// 260428 5월오픈 4번: 알림 설정 (카테고리 6종 + quiet hours + 채널 광고 동의)
export const notificationSettings = {
  preferences: '/api/user/notification/settings/preferences',
  preferenceUpdate: category => `/api/user/notification/settings/preferences/${category}`,
  quietHours: '/api/user/notification/settings/quiet-hours',
  marketingConsentUpdate: channel => `/api/user/notification/settings/marketing-consents/${channel}`
};

export const user = {
  signUp: '/api/user/join',
  // 261020 가입 지역 — 가입 직후 폰 위치 { lat, lng } (common/utils/signupRegion.js)
  signupRegion: '/api/user/signup-region',
  // HTTP METHOD : POST
  // PARAMETERS : UserJoinRequest, HttpServletResponse,
  logOut: '/api/user/log/out',
  // HTTP METHOD : POST
  // PARAMETERS : UserLogOutRequest, HttpServletResponse,
  deleteUser: `/api/user/delete`,
  canDeleteUser: userNo => `/api/user/check/delete/${userNo}`,
  // HTTP METHOD : PATCH
  // PathVariable : userNo
  renewDeviceInfo: '/api/user/renew/device-info',
  // HTTP METHOD : PATCH
  // PARAMETERS : UserRenewDeviceInfoRequest,
  renewAccessToken: '/api/user/renew/access-token',
  // HTTP METHOD : PATCH
  // PARAMETERS : UserRenewAccessTokenRequest, HttpServletResponse,
  renewFcmToken: '/api/user/renew/fcm-token',
  // HTTP METHOD PATCH
  // PARAMETERS : deviceInfo
  getUser: '/api/user/information',
  // HTTP METHOD : GET
  // PARAMETERS : Principal,
  logIn: '/api/user/log/in',
  // HTTP METHOD : PATCH
  // PARAMETERS : UserLogInRequest, HttpServletResponse,
  authCode: '/api/user/auth/phone',
  // 260710 P0: 인증번호 서버 검증(발송 응답으로 코드를 더 이상 내려주지 않음 — 서버 대조)
  smsVerify: '/api/user/auth/phone/verify',
  // HTTP METHOD : GET
  // PARAMETERS : NO PARAMETER
  findIdAuthCode: '/api/user/request/auth-code/id',
  joinAuthCode: '/api/user/join/auth/phone',
  findPasswordCode: '/api/user/request/auth-code/password',
  // HTTP METHOD : GET
  // PARAMETERS : phone
  familyCodeSearch: '/api/user/family',
  // HTTP METHOD : GET
  // PARAMETERS : familyCode
  emailDuplicated: '/api/user/check/email',
  // HTTP METHOD : GET
  // PARAMETERS : email
  findId: '/api/user/find/id/list',
  // HTTP METHOD : GET
  // PARAMETERS : phone , authCode,
  editPassword: '/api/user/update/password',
  // HTTP METHOD : PUT
  // PARAMETERS : userId , phone , password
  updateUser: '/api/user/profile', // 260716 P0: /update(web.ignoring)→/profile 이설로 ROLE_USER 인증(익명 IDOR fix)
  // HTTP METHOD : PATCH
  // PARMETERS : userNo(path) , phone , churchNo
  userItemCount: '/api/user/item/count/',
  // HTTP METHOD: GET
  // PathVariable : userNo
  userFamilyList: '/api/user/family/',
  // HTTP METHOD :GET
  // PathVariable : userNo
  editMarketing: '/api/user/agree/',
  editBusinessMarketing: '/api/user/agree/business/',
  // HTTP METHOD : PUT
  // PathVariable : userNo
  deathCertificate: '/api/board/death/submit',
  //  HTTP METHOD : POST
  // PARAMETERS : userNo , title , contents , firstFile , secondFile , thirdFile , fourthFile , fifthFile,
  userIdExists: '/api/user/find/password',
  // HTTP METHOD : GET,
  // PARAMETER : userId
  premiumNumberCheck: couponNumber => `/api/user/premium/${couponNumber}`,
  // HTTP METHOD : GET,
  // PathVariable : couponNumber
  updateUserPremium: (userNo, couponNumber) => `/api/user/premium/${userNo}/${couponNumber}`,
  // HTTP METHOD : GET,
  // PathVariable : userNo, couponNumber
  versionCheck: `/common/version-check`
  // HTTP METHOD : GET
  // PathVariable : UserDeviceDto
};

export const church = {
  searchChurch: '/api/church',
  // HTTP METHOD : GET,
  applyChurch: '/api/church/apply',
  // HTTP METHOD : PATCH,
  // PathVariable : churchNo / userNo
  getChurch: churchNo => `/api/church/${churchNo}`
  // HTTP METHOD : GET
  // PathVariable : churchNo
};

export const wellDying = {
  getList: '/api/wellDying',
  getMyList: '/api/wellDying/my',
  // HTTP METHOD : GET
  // PathVariable : {wellDyingType}
  getDetail: (category, wellNo, userNo) => `/api/wellDying/${category}/${wellNo}/${userNo}`,
  // HTTP METHOD : GET
  // PathVariable : wellDyingType , wellNo
  deleteWellDying: '/api/wellDying/',
  // HTTP METHOD : PATCH
  // PathVariable : wellDyingType , wellNo
  addWellDying: '/api/wellDying/save',
  // HTTP METHOD : POST
  // PARAMETERS : userNo , title , contents , firstFile , secondFile
  updateWellDying: '/api/wellDying/update'
  // HTTP METHOD : put
};

export const notice = {
  getList: '/api/board/notice',
  // HTTP METHOD : GET
  // PARAMETERS : page , limit,
  getDetail: '/api/board/notice/'
  // HTTP METHOD : GET
  // PathVariable : noticeNo
};

export const payment = {
  getList: '/api/payment',
  // HTTP METHOD : GET,
  // PARAMETERS : page , limit , userNo
  fetchSuperChat: userNo => `/api/payment/superchat/${userNo}`
};

export const premium = {
  getPremiumPointList: '/api/premium/point',
  // HTTP METHOD : GET,
  // PARAMETERS : BaseParameter
  getPoint: userNo => `/api/premium/point/${userNo}`
  // HTTP METHOD : GET,
  // PathVariable : userNo
};

export const notification = {
  getList: '/api/notification',
  // HTTP METHOD : GET
  // PARAMETERS : page , limit , userNo
  getDetail: '/api/notification/',
  // HTTP METHOD : GET
  // PathVariable : notificationNo
  updateRead: `/api/notification/read`,
  // 260618: 전체 읽음 (per-user + broadcast) — HTTP METHOD : PUT
  readAll: '/api/notification/read-all',
  // 260506: per-user 삭제 (broadcast는 admin 영역)
  // HTTP METHOD : DELETE  PathVariable : userNotiId  Query : userNo
  delete: userNotiId => `/api/notification/${userNotiId}`,
  // 260618: 전체 삭제 (per-user 삭제 + broadcast hide) — HTTP METHOD : DELETE
  deleteAll: '/api/notification/all',
  // 260506: badge 카운트 — broadcast + per-user 합산
  unreadCount: '/api/notification/unread/count'
};
export const inquiry = {
  getList: '/api/board/inquiry',
  // HTTP METHOD : GET
  // PARAMETERS : page , limit,
  getDetail: '/api/board/inquiry/',
  // HTTP METHOD : GET
  // PathVariable : inquiryNo
  addInquiry: '/api/board/inquiry'
  // HTTP METHOD :POST
  // PARAMETERS : userNo , title , contents , firstFile , secondFile , thirdFile , fourthFile , fifthFile
};

export const faq = {
  getList: '/api/board/faq',
  // HTTP METHOD : GET
  // PARAMETERS : page , limit,
  getDetail: '/api/board/faq/'
  // HTTP METHOD : GET
  // PathVariable : faqNo
};

export const law = {
  applyLaw: '/api/law/save',
  //HTTP METHOD : POST
  getList: '/api/law/lawyer'
  // HTTP METHOD : GET
  // page limit
};

// cry(추모관) FE 분해 Phase 1 — memorial·anniversary·funeral·announcement 정의는 cryApiList.js 로 이동.
// re-export 로 기존 `import { memorial } from '@/common/service/apiList'` 호환 유지.
export { memorial, anniversary, funeral, announcement } from './cryApiList';

export const emoticon = {
  buyList: userNo => `/api/user/emoticon/${userNo}`,
  smileMyEmoticonList: userNo => `/api/user/emoticon/${userNo}`,
  // HTTP METHOD : GET
  // PATH : userNo
  buy: '/api/user/emoticon/purchase/',
  // HTTP METHOD : PATCH
  // PATH : userNo / emoticonNo
  emoticonList: (userNo, funeralNo) => `/api/user/emoticon/shop/${userNo}/${funeralNo}`,
  smileEmoticonList: (userNo, smileNo) => `/api/user/emoticon/smile/shop/${userNo}/${smileNo}`,
  allEmoticonList: '/api/user/emoticon/all'
};

export const moreFamily = {
  getList: '/api/user/family/members',
  // HTTP METHOD : GET
  // PARAMETER : familyCode,
  updateFamilyName: '/api/user/family/update/',
  // HTTP METHOD : PUT
  // PathVariable : userNo
  joinFamily: '/api/user/family/join',
  // HTTP METHOD : POST
  // PARAMETERS : familyCode , userNo , name
  createFamily: '/api/user/family/create',
  // HTTP METHOD : POST
  // PARAMETERS : userNo , familyCode , familyName
  deleteFamily: '/api/user/family/',
  // HTTP METHOD : DELETE
  // PathVariable : familyNo
  addFamily: '/api/user/family/create'
  // HTTP METHOD : POST
  // PARAMETERS : familyCode , userNo , name
};
// (cry FE 분해) funeral·announcement 정의는 cryApiList.js 로 이동 — 위 re-export 참조.

export const item = {
  getProductListByCategory: (userNo, category) => `/api/shop/${userNo}/${category}`,
  // HTTP METHOD :GET
  getBuyMemorialList: '/api/user/item/memorial/',
  // HTTP METHOD :GET
  // PathVariable : userNo
  getCategoryShopList: (userNo, category) => `/api/shop/${userNo}/${category}`,
  // HTTP METHOD : GET
  // PathVariable : category
  getUserItem: '/api/user/item',
  // HTTP METHOD : GET
  extendMemorial: '/api/user/item/extend/memorial',
  smileBackgroundImageList: (userNo, category) => `/api/image/smile/background/${userNo}/${category}`
  // HTTP METHOD : PUT
  // PARAMETERS : userNo , preItemNo , useItemNo , memorialNo
};

export const diary = {
  pickedList: '/api/diary',
  monthList: '/api/diary/month',
  fetchDetail: diaryNo => `/api/diary/${diaryNo}`,
  save: '/api/diary/save',
  delete: diaryNo => `/api/diary/${diaryNo}`
};

// 260513 리텐션 보드 사용자 행동 추적 endpoint (인증 필요)
// RetentionBoardController.java @RequestMapping("/api/retention") + @PostMapping("/track/*")
export const retention = {
  sessionOpen: '/api/retention/track/session-open',
  feature: '/api/retention/track/feature'
};

// 261028 행동 로그 묶음 받기(인증 면제 — 손님 포함, 회원이면 토큰 주체로 묶는다). ActionLogController @RequestMapping("/api/log")
export const actionLog = {
  collect: '/api/log/actions'
};

// 260513 진입 전 1회 조회하는 feature flag (인증 면제)
export const config = {
  featureFlags: '/api/config/feature-flags',
  // 260624 마이노트(쉼) 화이트리스트 — 로그인 유저 기준 판정(인증 필요). 위 feature-flags(비로그인 번들)와 별개.
  mynoteAccess: '/api/config/mynote-access'
};

// 260919 통합 통계(/more/stats) — 현판 축·무료 현판 신청. QR 계열 첫 apiList 그룹(리터럴 산재 방지).
export const qrUser = {
  stats: businessNo => `/api/user/qr/stats/${businessNo}`,
  franchiseRequest: '/api/user/qr/franchise-request',
  franchiseStatus: '/api/user/qr/franchise-request/status',
  // 260923 대표 회의: 스마트스토어 오픈 전 현판 사전 신청 — QR 공개 경로(/api/qr/**, 무인증·비로그인 허용)
  preOrder: '/api/qr/pre-order'
};

// 260727 사업장별 디지털 멤버십. 전부 JWT 인증 + business_membership.enabled 서버 게이트.
export const membership = {
  joinByQr: qrCode => `/api/user/qr/membership/${qrCode}`,
  myCards: '/api/user/business/membership/my',
  detail: businessNo => `/api/user/business/membership/detail/${businessNo}`,
  owner: businessNo => `/api/user/business/membership/owner/${businessNo}`,
  operation: businessNo => `/api/user/business/membership/owner/${businessNo}/operation`,
  point: businessNo => `/api/user/business/membership/owner/${businessNo}/point`,
  benefit: businessNo => `/api/user/business/membership/owner/${businessNo}/benefit`,
  useCoupon: businessNo => `/api/user/business/membership/owner/${businessNo}/coupon/use`
};

// 260626 비즈톡(영업형 사업장 1:1 채팅) Slice 3. 전부 인증 필요(ROLE_USER).
export const talk = {
  openRoom: '/api/user/talk/room',                                          // POST {businessNo}
  sendMessage: '/api/user/talk/message',                                    // POST {talkRoomNo, contents}
  sendImage: '/api/user/talk/message/image',                                // multiPost FormData {talkRoomNo, image, contents?}
  getMessages: talkRoomNo => `/api/user/talk/room/${talkRoomNo}/messages`,  // GET ?page&size → { messages, counterpartLastReadNo }
  getRooms: '/api/user/talk/rooms',                                         // GET ?page&size
  unread: '/api/user/talk/unread'                                           // GET
};
//Project Name : null//Created at 2024-02-19 10:48:45
